/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class CategoryRepo {

    static $resource = 'categories';
    
    constructor($auth){
        $http = new Http($auth);        
    }

    show(id){
        return $http.get(CategoryRepo.$resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    store(data){
        return $http.post(CategoryRepo.$resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    all(){
        return $http.get(CategoryRepo.$resource).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    paginate(page, q, orderBy){
        let query = "page=" + page;
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(CategoryRepo.$resource + "/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    update(id, data){
        return $http.put(CategoryRepo.$resource + "/" + id, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
    
    delete(id){        
        return $http.delete(CategoryRepo.$resource + "/" + id).then((response) => {                        
            return Promise.resolve(response);
        }).catch((response) =>{            
            return Promise.reject(response);
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/repos/CategoryRepo.js